import Splide, { Options } from '@splidejs/splide-4';

import { _isOnScreen, _once } from '../../utils';

/**
 *
 * @param {string} selector css selector
 * @param {Options} options splide-carousel options
 */
function initSplideWidget4(selector: string, options: Options = {}) {
  return _isOnScreen(
    `.${selector}`,
    _once(() => {
      new Splide(`.${selector}`, {
        type: 'loop',
        pagination: false,
        perPage: 4,
        gap: 2,
        breakpoints: {
          600: {
            perPage: 1,
            fixedWidth: 264,
          },
          1024: {
            perPage: 2,
          },
        },
        ...options,
      }).mount();
    }),
  );
}
initSplideWidget4('splide--mention', {
  type: 'slide',
  perPage: 5,
  autoWidth: true,
  autoHeight: true,
  arrows: true,
  pagination: false,
  rewind: true,
  gap: '3rem',
  breakpoints: {
    600: {
      perPage: 1,
      arrows: false,
      pagination: true,
    },
    1024: {
      perPage: 2,
      arrows: false,
      pagination: true,
    },
  },
});
